<template>
      <!--====== APPIE SERRVICE 2 PART START ======-->
    
    <section class="appie-services-2-area pb-100" id="service-details">
        <div class="container">
            <div class="row align-items-end">
                <div class="col-lg-6 col-md-8">
                    <div class="appie-section-title">
                        <h3 class="appie-title">{{title}}</h3>
                        <p>{{description}}</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-4">
<!--                    <div class="appie-section-title text-right">-->
<!--                        <a class="main-btn" href="#">View all Features <i class="fal fa-arrow-right"></i></a>-->
<!--                    </div>-->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="appie-single-service-2 mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="200ms">
                        <div class="icon">
                            <i class="fas fa-bolt"></i>
                        </div>
                        <h4 class="title">Type Of the App</h4>
                        <p>Swing2App offers web app, custom and template app types. For web app creation, get started with
                          Create Web App option.</p>
<!--                        <a href="#">Read More <i class="fal fa-arrow-right"></i></a>-->
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="appie-single-service-2 item-2 mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="400ms">
                        <div class="icon">
                            <i class="fas fa-home"></i>
                        </div>
                        <h4 class="title">Website URL & Prototype</h4>
                        <p>Enter your website url link and then select web app prototype. We offer 2 types of prototype, WebView App & Push only.</p>
<!--                        <a href="#">Read More <i class="fal fa-arrow-right"></i></a>-->
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="appie-single-service-2 item-3 mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="600ms">
                        <div class="icon">
                            <i class="fas fa-link"></i>
                        </div>
                        <h4 class="title">App Name, Icon and Splash Screen</h4>
                        <p>Enter your website url link and then select web app prototype. We offer 2 types of prototype, WebView App & Push only.</p>
<!--                        <a href="#">Read More <i class="fal fa-arrow-right"></i></a>-->
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="appie-single-service-2 item-4 mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="200ms">
                        <div class="icon">
                            <i class="far fa-tools"></i>
                        </div>
                        <h4 class="title">Customize App</h4>
                        <p>Add Toolbar, menus, customize app color, link templates, features and more.</p>
<!--                        <a href="#">Read More <i class="fal fa-arrow-right"></i></a>-->
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="appie-single-service-2 item-5 mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="400ms">
                        <div class="icon">
                            <i class="fas fa-code"></i>
                        </div>
                        <h4 class="title">Free App Creation & Testing</h4>
                        <p>Finish App creation and install your APK file to test your app on Android device.</p>
<!--                        <a href="#">Read More <i class="fal fa-arrow-right"></i></a>-->
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="appie-single-service-2 item-6 mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="600ms">
                        <div class="icon">
                            <i class="fab fa-app-store"></i>
                        </div>
                        <h4 class="title">Upload App on App Store & Play Store upload</h4>
                        <p>Purchase our web app paid plans, fill store upload form and upload your app on store.</p>
<!--                        <a href="#">Read More <i class="fal fa-arrow-right"></i></a>-->
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <!--====== APPIE SERRVICE 2 PART ENDS ======-->
</template>

<script>
export default {
    props:{
        title:{
            type:String,
        },
        description:{
            type:String,
        }
    }

}
</script>

<style>

</style>